const styles = (theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		padding: 0,
	},
	boxHeader: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
	},
	boxDataGrid: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
	},
	paperContent: {
		borderRadius: "16px",
		backgroundColor: theme.palette.mode === "dark" && "transparent",
		display: "flex",
		flexDirection: "column",
		gap: 2,
		width: "100%",
		margin: 0,
		padding: "20px",
	},
	paperDatagrid: {
		width: "100%",
		overflowX: "auto",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
	},
	listContentMobile: {
		width: "100%",
		padding: 0,
	},
	boxList: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		padding: "5px",
	},
	chip: {
		padding: "5px",
		fontSize: "10px",
		textAlign: "center",
		width: "100px",
		position: "absolute",
		marginLeft: "50%",
		height: "auto",
		color: theme.palette.white.main,
		"& .MuiChip-label": {
			display: "block",
			whiteSpace: "normal",
		},
	},

	notificacoesBox: {
		display: "flex",
		flexDirection: "column",
		maxHeight: "287.6px",
		overflow: "auto",
		padding: 1,
		gap: 1,
	},
	notificacoesMobileBadge: { zIndex: "0" },
	listItens: {
		display: "flex",
		flexDirection: "row",
		padding: 0,
	},
	containerListItens: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		padding: "16px 0 0 16px",
		minHeight: "135px",
	},
	containerMenuMobile: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
	},
	menuItensMobile: {
		minWidth: "250px",
		display: "flex",
		alignItems: "center",
	},
	iconButton: {
		bgcolor: "background.paper",
		borderRadius: 0,
		height: "135px",
		":focus": {
			bgcolor: "background.paper",
		},
	},
	containerNameRazaoSocial: {
		width: "100%",
		maxWidth: "165px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	nomeFantasia: {
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		display: "block",
	},
	dataGrid: {
		display: "grid",
		"& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
			outline: "none !important",
		},
		"&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
			pt: "5px",
		},
		"&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
			py: "10px",
		},
		"&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
			py: "15px",
		},
	},
	launchIcon: {
		cursor: "pointer",
	},
	produtoCell: {
		display: "flex",
		alignItems: "center",
		gap: 0.5,
	},
	semProduto: {
		opacity: 0.4,
	},
	menuTituloProduto: {
		fontSize: 12,
		textTransform: "uppercase",
	},
	menuIconeMarcado: {
		marginRight: "16px",
	},
	menuIconeVazio: {
		marginRight: "16px",
		visibility: "hidden",
	},
});

export default styles;
